import arbitrumPairsGoerli from './arbitrumPairsGoerli.json';
import arbitrumPairsMainnet from './arbitrumPairsMainnet.json';
import basePairs from './basePairs.json';
import ethereumPairsGoerli from './ethereumPairsGoerli.json';
import ethereumPairsMainnet from './ethereumPairsMainnet.json';
import optimismPairsMainnet from './opPairs.json';
export var getPairs = function (_a) {
    var chainId = _a.chainId;
    var pairsList = [];
    switch (chainId) {
        case '1':
            pairsList = ethereumPairsMainnet;
            break;
        case '42161':
            pairsList = arbitrumPairsMainnet;
            break;
        case '11155111':
            pairsList = [];
            break;
        case '10':
            pairsList = optimismPairsMainnet;
            break;
        case '8453':
            pairsList = basePairs;
            break;
    }
    return pairsList;
};
export { ethereumPairsMainnet };
export { arbitrumPairsMainnet };
export { ethereumPairsGoerli };
export { arbitrumPairsGoerli };
